export const FILE_VALIDATION_I18N = {
	TITLE_SINGLE: "Fichier non autorisé",
	TITLE_MULTIPLE: "Fichiers non autorisés",
	GENERIC_TYPE_NOT_ACCEPTED: "Type de fichier non accepté",
	MULTIPLE_INVALID_PREFIX: "Certains fichiers ont des extensions non supportées:",
	RIB_GENERIC_TYPE_NOT_ACCEPTED: "Type de fichier non accepté pour le RIB",
	HEIC_CONVERT_FAILED:
		"Impossible de lire cette photo iPhone (HEIC). Enregistrez-la en JPEG ou PDF, ou ouvrez LeCoffre dans Safari.",
	EMPTY_PENDING_FILES: "Ajoutez au moins un fichier avant de confirmer.",
	DROP_UNREADABLE_TITLE: "Glisser-déposer indisponible",
	DROP_UNREADABLE_USE_PICKER:
		"Votre navigateur n'a pas transmis le fichier glissé. Cliquez sur la zone ou sur « Ajouter un document » pour le sélectionner.",
	WEBKITGTK_DROP_USE_PICKER:
		"GNOME Web (WebKitGTK) ne transmet plus le contenu des fichiers glissés. Cliquez sur la zone pour sélectionner le fichier.",
	UNKNOWN_TYPE_LABEL: "type inconnu",
	ACCEPTED_FORMATS_SHORT: "PDF, JPG, JPEG, PNG, HEIC, GIF, WebP, CSV, TXT, DOC, DOCX, PPT, PPTX, ODT, ODP",
} as const;
